import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
 
import styled from "styled-components";
import PageTopTitle from "../../components/shared/PageTopTitle";
import { getEgeyurtIletisim } from "../../features/admin/adminSlice";
import Button from "../../components/shared/button/Btn";
import { showModal } from "../../features/modal/modalSlice";
import EgeyutIletisimContainer from "../../components/adminContainers/EgeyutIletisimContainer";

const Container = styled.div`
  width: 100%;

  .wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    .content {
      margin: 25px 30px 0 30px;
      width: 1000px;

      @media (max-width: 1550px) {
        width: 100%;
        margin: 0;
        padding: 25px 30px 0px 30px;
      }
      .titles {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        gap: 10px;
        padding-inline: 10px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-lg);
        text-align: center;
        color: ${({ theme }) => theme.mainTextColor};
      }
      .btn-container {
        margin: 20px 0;
        display: flex;
        justify-content: flex-end;
      }
    }
  }
`;

const Egeyurtİletisim = () => {
  const { egeyurtIletisimList } = useSelector((state) => state.admin);
  const dispatch = useDispatch();

  const titles = ["Birim", "Telefon", "İşlemler"];

  useEffect(() => {
    dispatch(getEgeyurtIletisim());
  }, []);
  
  return (
    <Container>
      <div className="wrapper">
        <PageTopTitle title={"Egeyurt İletişim"} position="sticky" />
        <div className="content">
          <div className="btn-container">
            <Button color={"#E85546"}  background={"#fff"} width="240px" radius={"10px"} handleClick={() => dispatch(showModal("addEgeyurtIletisimItem"))}>Yeni İletişim Birimi Oluştur</Button>
          </div>

          <div className="titles">
            {titles.map((item) => (
              <p>{item}</p>
            ))}
          </div>

          {egeyurtIletisimList?.map((item)=> (
            <EgeyutIletisimContainer data={item} />
          )) 
          }
        </div>
      </div>
    </Container>
  );
};

export default Egeyurtİletisim;
